import { createProvider } from '.'

export default createProvider({})
